import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import css from 'styles/components/account/expandedTrackingProgress.scss';

const TRACKING_STATUS = {
  SHIPPING_SOON: 'shippingsoon',
  SHIPPED: 'shipped',
  IN_TRANSIT: 'intransit',
  OUT_FOR_DELIVERY: 'outfordelivery',
  DELIVERED: 'delivered'
};

const ExpandedTrackingProgress = ({ trackingInfo }) => {
  const { shipper, tracking, trackingNumber } = trackingInfo;
  const { statusCode, estimatedDeliveryDate } = tracking;

  const isDelivered = statusCode === TRACKING_STATUS.DELIVERED;
  const isOutForDelivery = statusCode === TRACKING_STATUS.OUT_FOR_DELIVERY || isDelivered;
  const isInTransit = statusCode === TRACKING_STATUS.IN_TRANSIT || isOutForDelivery || isDelivered;
  const isShipped = statusCode === TRACKING_STATUS.SHIPPED || isInTransit || isOutForDelivery || isDelivered;
  const isShippingSoon = statusCode === TRACKING_STATUS.SHIPPING_SOON || isShipped || isInTransit || isOutForDelivery || isDelivered;

  const shippingSoonClasses = cn({
    [css.stepActive]: statusCode === TRACKING_STATUS.SHIPPING_SOON,
    [css.stepComplete]: isShippingSoon
  });
  const shippedClasses = cn({
    [css.stepActive]: statusCode === TRACKING_STATUS.SHIPPED,
    [css.stepComplete]: isShipped
  });
  const inTransitClasses = cn({
    [css.stepActive]: statusCode === TRACKING_STATUS.IN_TRANSIT,
    [css.stepComplete]: isInTransit
  });
  const outForDeliveryClasses = cn({
    [css.stepActive]: statusCode === TRACKING_STATUS.OUT_FOR_DELIVERY,
    [css.stepComplete]: isOutForDelivery
  });
  const deliveredClasses = cn({
    [css.stepActive]: statusCode === TRACKING_STATUS.DELIVERED,
    [css.stepComplete]: isDelivered
  });

  return (
    <div className={css.shipmentDetails}>
      {estimatedDeliveryDate && <h2>Estimated delivery on {estimatedDeliveryDate}</h2>}
      <div className={css.trackingNumber}>{shipper} Tracking: {trackingNumber}</div>
      <div className={css.trackingProgress}>
        <ul className={css.steps}>
          <li className={cn(css.step, shippingSoonClasses)}>
            <span />
            <span>Processing</span>
          </li>
          <li className={cn(css.step, shippedClasses)}>
            <span />
            <span>Shipped</span>
          </li>
          <li className={cn(css.step, inTransitClasses)}>
            <span />
            <span>In transit</span>
          </li>
          <li className={cn(css.step, outForDeliveryClasses)}>
            <span />
            <span>Out for delivery</span>
          </li>
          <li className={cn(css.step, deliveredClasses)}>
            <span />
            <span>Delivered</span>
          </li>
        </ul>
      </div>
    </div>
  );
};

ExpandedTrackingProgress.contextTypes = {
  testId: PropTypes.func
};

ExpandedTrackingProgress.propTypes = {
  trackingInfo: PropTypes.object.isRequired
};

export default ExpandedTrackingProgress;
